import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const PrivacyPage = () => (
  <PublicLegalContentPage
    slug="privacy"
    seoTitle="Privacy Policy | Pleerity Enterprise Ltd"
    seoDescription="Learn how Pleerity Enterprise Ltd collects, uses, and protects your personal information in accordance with UK GDPR."
    canonicalUrl="/legal/privacy"
  />
);

export default PrivacyPage;
